import ReactDOM from 'react-dom';
import { FullyFundedProjectCallToAction } from './FullyFundedProjectCallToAction.js';

/* global isEligibleForFunding isInstantFundraisingEligible fullyFunded isTeacherViewingTheirOwnProject getRfParamTeacherId teacherId getFavList teacherScreenName teacherPossessivePronoun schoolGradeType schoolStateObj numActiveProjects activeProject */

export const main = () => {
    var targetElement = document.getElementById('fully-funded-cta');
    var targetElementMobile = document.getElementById('fully-funded-cta-mobile');

    if (!isEligibleForFunding && !isInstantFundraisingEligible && fullyFunded && !isTeacherViewingTheirOwnProject) {
        // check URL or cookie for teacher's rfParam
        var rfParamTeacherId = getRfParamTeacherId();
        if (rfParamTeacherId != null && rfParamTeacherId == teacherId) {
            if (targetElement) {
                renderFullyFundedProjectCTA(true, targetElement, false);
            }
            if (targetElementMobile) {
                renderFullyFundedProjectCTA(true, targetElementMobile, true);
            }
            return;
        }

        // if not signed in
        if (!userId) {
            if (targetElement) {
                renderFullyFundedProjectCTA(false, targetElement, false);
            }
            if (targetElementMobile) {
                renderFullyFundedProjectCTA(false, targetElementMobile, true);
            }
            return;
        }

        // check for favorited teacher
        $.when(getFavList('favTeacherIds')).then(function (favList) {
            if ($.inArray(teacherId, favList) > -1) {
                if (targetElement) {
                    renderFullyFundedProjectCTA(true, targetElement, false);
                }
                if (targetElementMobile) {
                    renderFullyFundedProjectCTA(true, targetElementMobile, true);
                }
            } else {
                if (targetElement) {
                    renderFullyFundedProjectCTA(false, targetElement, false);
                }
                if (targetElementMobile) {
                    renderFullyFundedProjectCTA(false, targetElementMobile, true);
                }
            }
        });
    }
};

function renderFullyFundedProjectCTA(isTeacherReferred, targetElement, mobileView) {
    ReactDOM.render(
        <FullyFundedProjectCallToAction
            teacherId={teacherId}
            teacherScreenName={teacherScreenName}
            teacherPossessivePronoun={teacherPossessivePronoun}

            schoolGradeType={schoolGradeType}
            schoolStateObj={schoolStateObj}

            numActiveProjects={numActiveProjects}
            activeProject={activeProject}

            isTeacherReferred={isTeacherReferred}
            isMobileView={mobileView}
        />,
        targetElement,
    );
}
